import {ref} from 'vue'

const confirmDialogStore = ref({
    opened: false
});

export default confirmDialogStore;
